<template>
  <div class="container-fluid">
    <f7-list media-list>
      <li class="item-content"
      v-for="remindSetting in remindSettings"
      @click="editRemindSetting(remindSetting)">
        <div class="item-media">
          <!-- <f7-icon f7="alarm_fill" class="streammindBlueFont"></f7-icon> -->
          <i class="icon list-icon icon-alarmclock"></i>
        </div>
        <div class="item-inner">
          <div class="item-title-row">
            <div class="item-title">{{ remindSetting.label }}</div>
          </div>
        </div>
      </li>
    </f7-list>
  </div>
</template>

<script>
// import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  props: ['remindSettings'],
  mounted () {
  },
  methods: {
    editRemindSetting (remindSetting) {
      this.$engine.settings.set({currentRemindSetting: remindSetting})
      loadPage(this, {url: '/settings/remind/edit/'})
    }
  }
}
</script>
